module.exports = __webpack_public_path__ + "img/titleimg.02d952ca.png";